"use client";

import { useEffect, useState, createContext, useContext } from "react";
import { createPortal } from "react-dom";
import s from "./Modal.module.scss";
import clsx from "clsx";
import { ModalTypes } from "@/types/modal";
import { updateStateSession } from "@/context/utils";
import { formatDate, generateUniqueId } from "../Forms/ConnectModalForm/utils";

const ModalContext = createContext({});
export const useModal = () => useContext(ModalContext);

export function ModalDialog({
  children,
  className,
  size = null,
  onClose,
  modalType,
  isMobile = false
}: React.PropsWithChildren<any>) {
  interface ContextFormData {
    countryCode?: string;
    mobile?: string;
    email?: string;
    name?: string;
  }
  
  const [contextFormData, setContextFormData] = useState<ContextFormData>({});

  const getModalContainerClass = (modalType: ModalTypes) => {
      switch(modalType){
        case ModalTypes.CallingSticky_Modal:
        case ModalTypes.CallUsModal_V2:
          return s.modalDialogParent
          default:
        return '';  
      }
  };

  const getModalClass = (modalType: ModalTypes) => {
    switch (modalType) {
      case ModalTypes.ConnectModal:
      case ModalTypes.ConnectModalLP:
      case ModalTypes.ConnectModalFormSponsoredCourses:
        return s.connectModalClose;
      case ModalTypes.CallUsModal_V2:
        return s.callUsModalClose;
      case ModalTypes.LoginModal:
        return s.loginClose;
      default:
        return '';
    }
  };

  const getModalClasses = (modalType: ModalTypes) => {
    let classes = ['bg-white'];
    
    switch (modalType) {
        case ModalTypes.PreDegreeModal:
          case ModalTypes.CallUsModal_V2:
            case ModalTypes.CallingSticky_Modal:
              classes.push('padding-0-imp');
              break; 
            }
            if(modalType === ModalTypes.ShareIcon ){
              classes.push(s.shareIcon)
            }
            
            if (modalType === ModalTypes.CallingSticky_Modal || modalType === ModalTypes.CallUsModal_V2) {
              classes.push(s.callUsModalClass);
            }
            classes.push(modalType === ModalTypes.PreDegreeModal ? s.dialogNew : s.dialog);
            
    return classes;
  };

  const leadCheckOnCompletion = async () => {
    let flag = false;
    let uniqueId = localStorage.getItem("uniqueLeadId");
          
    if (!uniqueId) {
            uniqueId = generateUniqueId();
            localStorage.setItem("uniqueLeadId", uniqueId);
          }

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const regex =
    contextFormData.countryCode === "+91"
        ? /^[1-9][0-9]{9}$/
        : /^[1-9][0-9]{6,14}$/;
    if ((!contextFormData.mobile || regex.test(contextFormData.mobile)) && emailRegex.test(contextFormData.email)) {
      if(contextFormData.countryCode==="Code"){
        contextFormData.countryCode=""
      }
      flag = true;
    } else if (regex.test(contextFormData.mobile)) {
      flag = true;
      if(contextFormData.countryCode==="Code"){
        flag=false;
      }
    }

    if(window.location.pathname.includes('/lp-nw'))
      flag=false;

    if(flag){
      try {
        setTimeout(async ()=>{
          const response = await fetch(
            "/api/leadsquared.com/lead-check",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                PhoneNo: contextFormData.mobile? contextFormData.mobile: "",
                EmailID: contextFormData.email || "",
                Name: contextFormData.name || "",
                CountryCode:contextFormData.countryCode,
                PageUrl:window.location.href,
                CommConsent:formatDate(new Date()),
                UniqueId: uniqueId,
              }),
            }
          );
      
          if (!response.ok) {
            throw new Error("Failed to submit data");
          }
        },2000)
      } catch (error) {
        console.error("Error submitting data:", error);
      }
    }
  };
  return (
    <ModalContext.Provider value={{contextFormData, setContextFormData }}>
    <div
     className={getModalContainerClass(modalType)}
    >
    <div
      className={clsx(...getModalClasses(modalType), className, { [s.xl]: size == "xl" })}
    >
      <svg
        onClick={(e) => {
          onClose();
          leadCheckOnCompletion();
          // reset global store
          updateStateSession({
            parentSection: ""
          })
        }}
        className={clsx(
        s.close, getModalClass(modalType))}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_380_520)">
          <path
            d="M18.2648 20.9813L11.6211 14.3376L4.9774 20.9813L2.76284 18.7667L9.40653 12.123L2.76284 5.47935L4.9774 3.26479L11.6211 9.90848L18.2648 3.26479L20.4794 5.47935L13.8357 12.123L20.4794 18.7667L18.2648 20.9813Z"
           fill="#1A325D"
          />
        </g>
        <defs>
          <clipPath id="clip0_380_520">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
      {children}
    </div>

    </div> 
    </ModalContext.Provider>
  );
}

const Modal = ({ modalId, parentId = "_modal", children }) => {
  const [el, setEl] = useState<HTMLElement | null>(null);
  
  useEffect(() => {
    let scrollPosition;
    let el = document.getElementById(parentId) as HTMLElement;
    let m = () => {
      scrollPosition = document.body.scrollTop;
      if (el) {
        setEl(el);
      }
    };
    if (modalId !== "") m();
    else {
      setEl(null);
      document.body.scrollTo(0, scrollPosition);
    }

    let listner = (e) => {
      console.log(e);
      console.log(window.location.hash);
      console.log("The hash has changed!");
    };

    window.addEventListener("hashchange", listner, false);

    return () => {
      window.removeEventListener("hashchange", listner, false);
    };
  }, [modalId, parentId]);

  return el ? createPortal(<div className={clsx(s.root,  ( modalId === "CallingSticky_Modal" || modalId==="CallUsModalV2") && s.callUsModal )}>{children}</div>, el) : null;
};

export default Modal;
